import { inject } from 'vue';

export default function useConfirmDialog() {
  const confirmDialog = inject('globalConfirmDialog');

  if (!confirmDialog) {
    throw new Error(
      'useConfirmDialog must be used within a component that has access to globalConfirmDialog',
    );
  }

  return confirmDialog.confirm;
}
